import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { Router } from '@angular/router';
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';

@Component({
  selector: 'share-dialog',
  templateUrl: 'share-superadmin-dialog.html',
  styleUrls: ['share-superadmin-dialog.css']
})
export class ShareSurveyservice {
  // email: string;
  // isSharable:boolean;
  // isInvalid:boolean;
  managerList = [];
  result: any;
  noManager: boolean;
  showLoader: boolean;
  displayedColumns = ['email', 'addedOn', 'status','action'];
  constructor(private router: Router,
    public dialogRef: MatDialogRef<ShareSurveyservice>, public restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any, private toastyService: ToastyService, private toastyConfig: ToastyConfig) {
    // this.isSharable  = true;
    // this.isInvalid = false;
    this.showLoader = true
    // this.noTeamCreated = true;
    this.restApiService.getManagersList().subscribe(
      result => {
        this.managerList=[];
        this.showLoader = false;
        if (result.success == true) {
          if (result.data.length > 0) {
            this.noManager = false;
            result = result.data;
            this.result = result;
            for (var i in result) {
              if (this.data.sharedWith != null) {
                if (this.data.sharedWith.includes(this.result[i].adminID)) {
                  this.managerList.push({ name: result[i].email, created: result[i].created, sharing: result[i].Status, status: 'SHARED' })
                }
                else {
                  this.managerList.push({ name: result[i].email, created: result[i].created, sharing: result[i].Status, status: 'SHARE' })
                }
              }
              else {
                this.managerList.push({ name: result[i].email, created: result[i].created, Sharing: result[i].Status, status: 'SHARE' })
              }
            }
          }
          else {
            this.noManager = true;
          }
        }
        else {
          // console.log(result);
        }
      });
  }
  assign(data) {
    if (this.result[data].Status == 1) {
      this.restApiService.shareQnr(this.managerList[data].name, this.data.qID).subscribe(
        result => {
          if (result.success != false) {
            this.managerList[data].status = 'SHARED';
            // this.isSharable  = false;
            this.addToast(true, false, false, this.managerList[data].name);
          }
          else {
            // this.dialogRef.close();
          }
        });
    }
    else if (this.result[data].Status == 2 || this.result[data].Status == 3) {
      this.addToast(false, true, false, this.managerList[data].name);
    }
    else if (this.result[data].Status == 4) {
      this.addToast(false, false, true, this.managerList[data].name);

    }
  }
  unassign(data) {
    this.restApiService.removeManagerFromShare(this.managerList[data].name, this.data.qID).subscribe(
      result => {
        if (result.success != false) {
          this.managerList[data].status = 'SHARE';
          var toastOptions: ToastOptions = {
            title: "Survey Unassigned",
            msg: this.managerList[data].name + ' was unassigned the survey',
            showClose: true,
            timeout: 3000,
            theme: 'bootstrap'
          };
          this.toastyService.warning(toastOptions);
          // this.isSharable  = false;
        }
        else {
          // console.log(result);
          // this.dialogRef.close();
        }
      });
  }

  addToast(shared: boolean, pending: boolean, declined: boolean, email: string) {
    if (shared) {
      var toastOptions: ToastOptions = {
        title: "Survey Shared",
        msg: this.data.surveyName + ' was successfully shared with ' + email,
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.success(toastOptions);
    } else if (pending) {
      var toastOptions: ToastOptions = {
        title: "Survey Not Shared",
        msg: email + ' has not accepted the invitation yet',
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    } else if (declined) {
      var toastOptions: ToastOptions = {
        title: "Survey Not Shared",
        msg: email + ' declined your invitation.',
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }
  }
  close() {
    this.dialogRef.close();
  }
  createManager() {
    this.dialogRef.close();
    this.router.navigateByUrl('/manager-data');
  }
}



// WEBPACK FOOTER //
// ./src/app/questionnaires/share-superadmin-dialog.ts